import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { SubSink } from 'subsink';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-newsletter-dialog',
  templateUrl: './newsletter-dialog.component.html',
  styleUrls: ['./newsletter-dialog.component.scss'],
})
export class NewsletterDialogComponent implements OnInit, OnDestroy {
  constructor(public dialogRef: MatDialogRef<NewsletterDialogComponent>) {}

  private subs = new SubSink();

  public displayMiniCrmScript(): void {
    const miniCrmScript: HTMLScriptElement = document.createElement('script');

    miniCrmScript.type === 'text/javascript';
    miniCrmScript.async = true;
    miniCrmScript.src = environment.newsletterScriptUrl;

    document
      .querySelector('#footer-newsletter-block')!
      .appendChild(miniCrmScript);
  }

  ngOnInit(): void {
    const dialogSubscription = this.dialogRef.afterOpened().subscribe(() => {
      this.displayMiniCrmScript();
    });

    this.subs.add(dialogSubscription);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
